import MuiAlert from "@material-ui/lab/Alert";

export type TAlertType = "success" | "info" | "warning" | "error";

interface IProps {
  type: TAlertType;
  [property: string]: any;
}

const Alert = ({ type, ...props }: IProps) => {
  return (
    <MuiAlert
      {...props}
      elevation={3}
      variant="filled"
      severity={type}
      color={type}
    />
  );
};

export default Alert;
